import { render, staticRenderFns } from "./getNotice.vue?vue&type=template&id=f732b792&scoped=true&"
import script from "./getNotice.vue?vue&type=script&lang=js&"
export * from "./getNotice.vue?vue&type=script&lang=js&"
import style0 from "./getNotice.vue?vue&type=style&index=0&id=f732b792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f732b792",
  null
  
)

export default component.exports